import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceSetup } from 'src/app/model/invoiceSetup';
import { AuthService } from 'src/app/services/auth.service';
import { InvoiceSetupService } from 'src/app/services/invoice-setup.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'aw-invoice-card',
  templateUrl: './invoice-card.component.html',
  styleUrls: ['./invoice-card.component.scss']
})
export class InvoiceCardComponent implements OnInit {
  @Output() saved = new EventEmitter<void>();
  invoice?: InvoiceSetup;
  loading = false;
  loggedUser: any;


  constructor(
    private snackService: SnackService,
    public dialog: MatDialog,
    public invoiceService: InvoiceSetupService,
    public authService: AuthService

  ) { }

  @Input() set element(invoice: InvoiceSetup) {
    this.invoice = invoice;
  }

  editItems(invoice: InvoiceSetup) {
    this.invoiceService.updateInvoice(invoice).subscribe({
      next: (value => {


        this.snackService.success('Contract updated!');
        this.saved.emit();
      }),
      error: (err => {
        this.snackService.error(err);
      })
    })
  }

  ngOnInit(): void {

    this.loggedUser = this.authService.loggedUser();

  }

}
